import { render } from "./App.vue?vue&type=template&id=2f9c6ce2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2f9c6ce2&lang=less"

import exportComponent from "D:\\Data_code\\Vue\\196116_com_4000_ver2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__